export const CHECK_ACCOUNT_CREATED = 'page/CHECK_ACCOUNT_CREATED';
export const RECOGNISE_ACCOUNT_CREATED_NOTIFICATION =
    'page/RECOGNISE_ACCOUNT_CREATED_NOTIFICATION';
export const CLOSE_ACCOUNT_CREATED_NOTIFICATION =
    'page/CLOSE_ACCOUNT_CREATED_NOTIFICATION';
